const sherpaBlue = "#1e4f56"
const lynch = "#667c92"
const cascade = "#86A9A5"
const geyser = "#d4e5e6"
const lotus = "#89373b"
const almostWhite = "#F5F5F5"

const colours = {
  turquoise: {
    veryDark: sherpaBlue,
    dark: lynch,
    mid: cascade,
    light: geyser
  },
  red: {
    dark: lotus
  },
  grey: {
    almostWhite
  }
}

const theme = {
  spacing: n => n * 8,
  palette: {
    ...colours,
    menuFG: colours.grey.almostWhite,
    menuBG: colours.turquoise.mid,
    galleryBG: colours.turquoise.light,
    fg: {
      darkGreen: "#1d4a3d",
      pink: "#f19990",
      darkPink: "#e73358",
      cream: "#fceacb",
      test: "#000"
    }
  }
}

export default theme
